import React, { useState, useEffect, useCallback } from 'react';
import { RootState } from '../Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../Redux/authSlice';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Card, Breadcrumb, Pagination } from 'react-bootstrap';
import "./Sales.css"
interface SalesReturn {
    id: number;
    sale: number;
    sales_name: string;
    product_name: string;
    product: number;
    quantity: number;
    reason: string;
    date_returned: string;
    total_refund: string;
    return_approved: boolean;
}

export default function SalesReturnComponent() {
    const [salesReturns, setSalesReturns] = useState<SalesReturn[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedReturn, setSelectedReturn] = useState<SalesReturn | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [searchTerm, setSearchTerm] = useState<string>('');

    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    const fetchData = useCallback(async () => {
        try {
            const token = getCookie('token');
            if (!token) {
                dispatch(setAuth(false));
                return;
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            await axios.get('https://api.sominnovations.xyz/users/user', {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            dispatch(setAuth(true));
        } catch (e) {
            dispatch(setAuth(false));
        }
    }, [dispatch]);

    const fetchSalesReturns = useCallback(async (page: number) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://api.sominnovations.xyz/Branches/sales-returns/?page=${page}&search=${searchTerm}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setSalesReturns(response.data.results);
            setTotalPages(Math.ceil(response.data.count / 20));
            console.log(response.data);
        } catch (error) {
            console.error('Error fetching sales returns:', error);
        }
        setLoading(false);
    }, [searchTerm]);

    useEffect(() => {
        fetchData();
    }, [dispatch, fetchData]);

    useEffect(() => {
        if (auth) {
            fetchSalesReturns(currentPage);
        }
    }, [auth, currentPage, searchTerm, fetchSalesReturns]);

    const handleView = (saleReturn: SalesReturn) => {
        setSelectedReturn(saleReturn);
        setShowModal(true);
    };
    const handleDelete = async (id: number) => {
        // Show confirmation dialog
        const confirmed = window.confirm("Are you sure you want to delete this sales return?");

        // If the user confirms, proceed with the delete operation
        if (confirmed) {
            try {
                await axios.delete(`https://api.sominnovations.xyz/Branches/sales-returns/${id}/`, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                // Update the salesReturns state to remove the deleted item
                setSalesReturns(salesReturns.filter((saleReturn) => saleReturn.id !== id));
            } catch (error) {
                console.error("Error deleting sales return:", error);
            }
        }
    };

    return (
        <div className="container mt-1 sales-return-container">
            <Card className="mb-4">
                <Card.Header style={{ backgroundColor: '#5271ff', color: '#fff' }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h4>Sales Returns</h4>
                        <Breadcrumb>
                            <Breadcrumb.Item href="dashboard"><p style={{ color: "white" }}>Dashboard</p></Breadcrumb.Item>
                            <Breadcrumb.Item active>Sales Returns</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="mb-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search Sales Returns..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </Card.Body>
            </Card>

            {loading ? (
                <div>Loading...</div>
            ) : (
                <>
                    <div className='table-responsive-sm'>
                        <table className="table table-striped table-responsive table-sm" style={{ fontSize: '14px', margin: 'auto' }}>
                            <thead className="table-dark">
                                <tr>
                                    <th>ID</th>
                                    <th>Sale</th>
                                    <th>Product</th>
                                    <th>Quantity</th>
                                    <th>Reason</th>
                                    <th>Date Returned</th>
                                    <th>Total Refund</th>
                                    <th>Return Approved</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {salesReturns.map((saleReturn) => (
                                    <tr key={saleReturn.id}>
                                        <td>{saleReturn.id}</td>
                                        <td>{saleReturn.sales_name}</td>
                                        <td>{saleReturn.product_name}</td>
                                        <td>{saleReturn.quantity}</td>
                                        <td>{saleReturn.reason}</td>
                                        <td>{new Date(saleReturn.date_returned).toLocaleDateString()}</td>
                                        <td>{saleReturn.total_refund}</td>
                                        <td>{saleReturn.return_approved ? "Yes" : "No"}</td>
                                        <td>
                                            <Button variant="info" size="sm" onClick={() => handleView(saleReturn)}>
                                                View
                                            </Button>
                                            <Button variant="danger" size="sm" onClick={() => handleDelete(saleReturn.id)} className="mx-1">
                                                Delete
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <Pagination>
                        {Array.from({ length: totalPages }).map((_, i) => (
                            <Pagination.Item key={i} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                                {i + 1}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </>
            )}

            {selectedReturn && (
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Sales Return</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p><strong>Sale ID:</strong> {selectedReturn.sale}</p>
                        <p><strong>Product ID:</strong> {selectedReturn.product}</p>
                        <p><strong>Quantity:</strong> {selectedReturn.quantity}</p>
                        <p><strong>Reason:</strong> {selectedReturn.reason}</p>
                        <p><strong>Date Returned:</strong> {new Date(selectedReturn.date_returned).toLocaleDateString()}</p>
                        <p><strong>Total Refund:</strong> {selectedReturn.total_refund}</p>
                        <p><strong>Return Approved:</strong> {selectedReturn.return_approved ? "Yes" : "No"}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </div>
    );
}
